// React
import { createContext } from "react"

export const ParamsContext = createContext<{
  isDisabled?: boolean
}>({
  isDisabled: false
})